module.exports = {
  primary: '#0F3C50',
  lightgray: '#FAFAFA',
  darkgray: '#787878',
  blue: '#568ca5',
  purple: '#4061BC',
  lightPurple: '#3C50A00D',
  white: '#fff',
}
